export default "./dist/stdassets/images/icons/edit-cut.png";